import { render, staticRenderFns } from "./SystemFeedback.vue?vue&type=template&id=d45a3410&scoped=true&"
import script from "./SystemFeedback.vue?vue&type=script&lang=js&"
export * from "./SystemFeedback.vue?vue&type=script&lang=js&"
import style0 from "./SystemFeedback.vue?vue&type=style&index=0&id=d45a3410&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d45a3410",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAlert,VIcon})
